import split from 'lodash/split'
import { generateId } from '../generate-id'
import { isValidEmail } from '../is-valid'

export const toFakeEmail = (
  originalEmail: string,
  options: { domainName?: string } = { domainName: 'mailinator.com' }
): string => {
  if (!isValidEmail(originalEmail)) throw new Error('Invalid email format.')
  const splitEmail = split(originalEmail, '@')

  //we just skip if the email length is not 2
  if (splitEmail.length !== 2) throw new Error('Invalid email format.')

  const emailWithoutDomain = `${splitEmail[0]}.${generateId(2)}`
  return `${emailWithoutDomain}@${options.domainName}`.toLowerCase()
}
